<div class="container">
    <div *ngFor="let img of item.images; let i = index" class="product-images" (click)="triggerClickEffect()">
        <img [src]="serverPath+img.img" (click)="img.navigation == 0 ? imageNavigation(img.catId) 
        : link(img.navigatedUrl)" alt="Muster Men's Grooming Products" />
        <div class="click-effect" [class.active]="isClicked"></div>
    </div>
</div>
